import { render, staticRenderFns } from "./AppLandingCardAverageProductivity.vue?vue&type=template&id=6cb95461&scoped=true&"
import script from "./AppLandingCardAverageProductivity.vue?vue&type=script&lang=js&"
export * from "./AppLandingCardAverageProductivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb95461",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCard,VIcon,VScrollXTransition,VSkeletonLoader,VSparkline})
